import { render, staticRenderFns } from "./SelectSuspend.vue?vue&type=template&id=7669dcde&"
import script from "./SelectSuspend.vue?vue&type=script&lang=js&"
export * from "./SelectSuspend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports